// signalr/SignalRContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { useSelector } from "react-redux";
import * as notificationsConnection from "./notificationsConnection";

const SignalRContext = createContext();

/**
 * Expone la conexión única de notificationsConnection y su estado.
 * No crea ni detiene conexiones al montarse o desmontarse: la conexión vive mientras dure la sesión de la pestaña.
 */
export const SignalRProvider = ({ children }) => {
    const [snapshot, setSnapshot] = useState(notificationsConnection.getSnapshot);

    // Dependencias por valor (string / bool), no por el objeto settings
    const notificationsApi = useSelector(state => state.settings?.settings?.notificationsApi);
    const isAuthenticated = useSelector(state => state.authentication?.isAuthenticated);

    useEffect(() => {
        setSnapshot(notificationsConnection.getSnapshot());
        return notificationsConnection.onStateChange(setSnapshot);
    }, []);

    useEffect(() => {
        if (notificationsApi && isAuthenticated)
            notificationsConnection.start(notificationsApi);
    }, [notificationsApi, isAuthenticated]);

    const { connection, state } = snapshot;
    const isConnected = state === signalR.HubConnectionState.Connected;

    const sendMessage = (method, ...args) => {
        if (connection?.state === signalR.HubConnectionState.Connected) {
            return connection.invoke(method, ...args).catch(err => console.log("Error al enviar:", err));
        }
        return Promise.resolve();
    };

    return (
        <SignalRContext.Provider value={{ connection, isConnected, sendMessage }}>
            {children}
        </SignalRContext.Provider>
    );
};

export const useSignalRContext = () => {
    const ctx = useContext(SignalRContext);
    if (!ctx) throw new Error("useSignalRContext debe usarse dentro del SignalRProvider");
    return ctx;
};
